import { FC } from "react";
import ColumnSwitches from "./options/columnSwitches/ColumnSwitches";
import SideBarFiltersButton from "./options/filters/buttonOpenSideBar/SideBarFiltersButton";
import DataDateRangePicker from "./options/datePicker/dataDateRangePicker";
import { ExportButton } from "./options/export/ExportButton";
import Views from "./options/views/Views";
import DataTableColumns from "../columnsAndActions/ColumnsAndActions";
import { useDispatch, useSelector } from "react-redux";
import {
  selectDataTableUnifiedState,
  selectExportDataState,
} from "../../../../redux/selectors/unifiedSelectors";
import {
  setDateRangePicker,
  setOpenDateRangePicker,
} from "../../../../redux/slices/dataTable/dataTableFilters";
import { ThunkDispatch } from "@reduxjs/toolkit";
import { setFiltersDataTableActions } from "../../../../redux/actions/dataTable/DataTableAsyncActions";

export type MenuOptionsProps = {
  isViewerOnly: boolean;
  loadings: boolean;
};

const SetActions = () => {
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
  return {
    openRangeDate: () => dispatch(setOpenDateRangePicker(true)),
    closeRangeDate: () => dispatch(setOpenDateRangePicker(false)),

    setFiltersDataTableActions: () => {
      dispatch(setFiltersDataTableActions());
    },

    setActivityDate: (date: Date[]) => {
      dispatch(setDateRangePicker(date));
    },
  };
};

const MenuOptions: FC<MenuOptionsProps> = ({ isViewerOnly, loadings }) => {
  const { columnsDataTable, actionsDataTable } = DataTableColumns();

  const { loading, filters, tableOptions } = useSelector(
    selectDataTableUnifiedState
  );
  const { loadingExport } = useSelector(selectExportDataState);

  const isDisabled = columnsDataTable.length === 0 || loading;
  const {
    setActivityDate,
    openRangeDate,
    closeRangeDate,
    setFiltersDataTableActions,
  } = SetActions();

  const {
    selectDataDateActivity,
    filtersSelectedLength,
    loadingFilters,
    selectDateRangePickerOpen,
  } = filters;

  const loadingsValues = loading || loadingExport || loadingFilters;

  return (
    <div className="panel-options">
      <div className="options-left-data-panel">
        <div className="data-date-range-picker">
          <DataDateRangePicker
            setActivityDate={setActivityDate}
            selectDataDateActivity={selectDataDateActivity}
            openRangeDate={openRangeDate}
            closeRangeDate={closeRangeDate}
            callTheFetchData={setFiltersDataTableActions}
            open={selectDateRangePickerOpen}
            //optional
            filtersSelectedLength={filtersSelectedLength}
            loading={loadingsValues}
            actionsDataTable={actionsDataTable}
            columnsDataTable={columnsDataTable}
            tableOptions={tableOptions}
          />
        </div>
        <div className="data-extra-filters">
          <SideBarFiltersButton loading={loadings} disabled={isDisabled} />
        </div>
        <div className="data-extra-filters">
          <ColumnSwitches loading={loadings} disabled={isDisabled} />
        </div>
        <div className="data-extra-filters">
          <Views loading={loadings} disabled={isDisabled} />
        </div>
      </div>
      <div className="options-right-data-panel">
        <div>
          {!isViewerOnly && (
            <ExportButton loading={loadings} disabled={isDisabled} />
          )}
        </div>
      </div>
    </div>
  );
};

export default MenuOptions;
